
<template>
  <div id="password-policy-modal" class="modal fade" tabindex="-1"
       data-bs-backdrop="static" aria-hidden="true"
       data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <h4 class="modal-title">{{$t("policies.password")}}</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <validation-errors v-bind:errors="summaryErrors"></validation-errors>
          パスワードは○文字以上、○文字以内で入力してください。
        </div>
        <div class="modal-footer border-top-0 justify-content-between">
          <button type="button" class="btn btn-outline-success" v-on:click="closePasswordPolicyModal">{{$t("buttons.close")}}</button>
        </div>
      </div>
    </div>
  </div>
  <button type="button" class="btn btn-link p-0" v-on:click="openPasswordPolicyModal">{{$t("policies.password")}}</button>
</template>
<script>
  import { defineComponent } from "vue";
  import validationErrors from "components/base/validation_errors";
  import { Modal } from "bootstrap";

  export default defineComponent({
    components: {
      "validation-errors": validationErrors,
    },
    data: () => {
      return {
        loading: false,
        summaryErrors: [],
        errors: {},
      }
    },
    mounted() {
      this.passwordModal = new Modal(document.getElementById("password-policy-modal"));
    },
    methods: {
      openPasswordPolicyModal() {
        this.passwordModal.show();
      },
      closePasswordPolicyModal() {
        this.passwordModal.hide();
      },
    }
  });
</script>

